
import Button from '@/components/elements/Button.vue'

export default {
  name: 'NotFound',

  components: {
    Button
  }
}
